/**
 * Opens a Live playlist in TriadMusic Studio (new tab).
 * Available for every user with access to the playlist (editors and viewers);
 * Studio resolves the linked/shared project or imports the playlist.
 */
export const getStudioBaseUrl = () => {
    const host = window.location.hostname;
    const isDev = host === 'localhost' || host === '127.0.0.1' || host.includes('dev') || host.includes('staging') || host.includes('development');
    return isDev ? 'https://studio-dev.triadmusic.app' : 'https://studio.triadmusic.app';
};

export const openPlaylistInStudio = (playlistId) => {
    if (!playlistId) return;
    window.open(`${getStudioBaseUrl()}/?live_playlist_id=${encodeURIComponent(String(playlistId))}`, '_blank');
};
